module.exports = __webpack_public_path__ + "8eca7bcafec107506f2cce69fa98c78e.png";